/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdPopconfirmProps } from './type';

export const popconfirmDefaultProps: TdPopconfirmProps = {
  destroyOnClose: true,
  placement: 'top',
  showArrow: true,
  theme: 'default',
};
